import { defineMessages } from 'react-intl';

/* eslint-disable max-len */

export default defineMessages({
  companyMunicipalitiesLabel: {
    id: 'report.basicInfo.companyMunicipalities',
    description: 'Company municipalities',
    defaultMessage: 'Toimialueet',
  },
  companyMunicipalitiesLabelWholeCountryFi: {
    id: 'report.basicInfo.companyMunicipalitiesLabelWholeCountryFi',
    description: 'Whole Finland',
    defaultMessage: 'Koko Suomi',
  },
  companyMunicipalitiesLabelHometown: {
    id: 'report.basicInfo.companyMunicipalitiesLabelHometown',
    description: 'Hometown',
    defaultMessage: 'Kotikaupunki',
  },
  companyKeywordsLabel: {
    id: 'report.basicInfo.companyKeywords',
    description: 'Company keywords',
    defaultMessage: 'Hakusanat',
  },
  marketingName: {
    id: 'report.summary.marketingName',
    description: 'Marketing name',
    defaultMessage: 'Yrityksen antama markkinointinimi',
  },
  industry: {
    id: 'report.summary.industry',
    description: 'Industry',
    defaultMessage: 'Toimiala',
  },
  marketingNamePlaceholder: {
    id: 'report.summary.marketingNamePlaceholder',
    description: 'Marketing name placeholder',
    defaultMessage: 'markkinointinimi',
  },
  marketingNameLabel: {
    id: 'report.summary.marketingNameLabel',
    description: 'Marketing name label',
    defaultMessage: 'Markkinointinimi',
  },
  primaryNameLabel: {
    id: 'report.summary.primaryNameLabel',
    description: 'Primary name label',
    defaultMessage: 'Viralliset nimet',
  },
  auxiliaryNamesLabel: {
    id: 'report.summary.alternativeNamesLabel',
    description: 'Alternative names label',
    defaultMessage: 'Aputoiminimet',
  },
  marketingNameInfo: {
    id: 'report.summary.marketingNameInfo',
    description: 'Marketing name info',
    defaultMessage: 'Markkinointinimi on yrityksen vapaasti valittava epävirallinen nimi, joka näytetään ensisijaisena nimenä Zeckit-sivustolla.',
  },
  primaryNameInfo: {
    id: 'report.summary.primaryNameInfo',
    description: 'Primary name info',
    defaultMessage: 'Yrityksen virallista yritysrekisterissä olevaa ensisijaista nimeä tai aputoiminimiä ei voi muokata vapaasti.',
  },
  auxiliaryNamesInfo: {
    id: 'report.summary.alternativeNamesInfo',
    description: 'Alternative names info',
    defaultMessage: 'Yrityksellä voi olla useita vapaavalintaisia aputoiminimiä, jotka voivat olla esimerkiksi entisiä nimiä tai vaihtoehtoisia kirjoitusasuja.',
  },
  expandList: {
    id: 'report.summary.expandList',
    description: 'Click to expand list',
    defaultMessage: 'Näytä kaikki',
  },
  contractList: {
    id: 'report.summary.contractList',
    description: 'Click to contract list',
    defaultMessage: 'Näytä vähemmän',
  },
});
